export { default as Img200 } from './processed/200/usnavyflag.jpg';
export { default as Img400 } from './processed/400/usnavyflag.jpg';
export { default as Imgthumb } from './processed/thumb/usnavyflag.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/usnavyflag.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/usnavyflag.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      76,
      106,
      182
    ],
    "_population": 356,
    "_hsl": [
      0.6194968553459119,
      0.42063492063492075,
      0.5058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      132,
      188,
      248
    ],
    "_population": 5,
    "_hsl": [
      0.5862068965517241,
      0.8923076923076925,
      0.7450980392156863
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      55,
      23,
      85
    ],
    "_population": 82,
    "_hsl": [
      0.7526881720430109,
      0.574074074074074,
      0.21176470588235294
    ]
  },
  "Muted": {
    "_rgb": [
      153,
      110,
      97
    ],
    "_population": 85,
    "_hsl": [
      0.038690476190476226,
      0.224,
      0.49019607843137253
    ]
  },
  "LightMuted": {
    "_rgb": [
      210,
      175,
      167
    ],
    "_population": 16,
    "_hsl": [
      0.031007751937984506,
      0.3233082706766916,
      0.7392156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      88,
      60,
      50
    ],
    "_population": 239,
    "_hsl": [
      0.043859649122807015,
      0.2753623188405797,
      0.27058823529411763
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/usnavyflag.js